/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderTaskWorkflowItemConfigurationsRequest
 */
export interface ReorderTaskWorkflowItemConfigurationsRequest {
    /**
     * Every configuration on the organization's base list, in the new order.
     */
    configuration_ids: Set<string>;
}

/**
 * Check if a given object implements the ReorderTaskWorkflowItemConfigurationsRequest interface.
 */
export function instanceOfReorderTaskWorkflowItemConfigurationsRequest(value: object): value is ReorderTaskWorkflowItemConfigurationsRequest {
    if (!('configuration_ids' in value) || value['configuration_ids'] === undefined) return false;
    return true;
}

export function ReorderTaskWorkflowItemConfigurationsRequestFromJSON(json: any): ReorderTaskWorkflowItemConfigurationsRequest {
    return ReorderTaskWorkflowItemConfigurationsRequestFromJSONTyped(json, false);
}

export function ReorderTaskWorkflowItemConfigurationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderTaskWorkflowItemConfigurationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'configuration_ids': new Set(json['configuration_ids']),
    };
}

export function ReorderTaskWorkflowItemConfigurationsRequestToJSON(json: any): ReorderTaskWorkflowItemConfigurationsRequest {
    return ReorderTaskWorkflowItemConfigurationsRequestToJSONTyped(json, false);
}

export function ReorderTaskWorkflowItemConfigurationsRequestToJSONTyped(value?: ReorderTaskWorkflowItemConfigurationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration_ids': Array.from(value['configuration_ids'] as Set<any>),
    };
}

